// extracted by mini-css-extract-plugin
export default {"custom-error-message":"CustomErrorMessage_custom-error-message__cVYSR"};